import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import LocationSearch from '../../../components/location-search'
import { SettingsField } from '../../../components/Settings/ClearableInput'
import SettingsCard from '../../../components/Settings/SettingsCard'
import { formatCharityLocationDisplay } from '../../../lib/charityLocation'

function CharityLocationField({ label, value, onChange, placeholder }) {
  return (
    <SettingsField label={label}>
      <LocationSearch
        onChange={onChange}
        placeholder={placeholder}
        value={formatCharityLocationDisplay(value)}
      />
    </SettingsField>
  )
}

CharityLocationField.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
}

export default function CharityLocationsCard({
  locations,
  clearedLocations,
  onLocationChange,
  onSave,
  hasChanged,
  isSaving,
}) {
  const { t } = useTranslation()

  return (
    <SettingsCard
      icon="location-dot"
      title={t('charities.settings.locations_title')}
      description={t('charities.settings.locations_note')}
      actions={
        <button
          className="btn btn-primary"
          type="button"
          onClick={onSave}
          disabled={!hasChanged || isSaving}
        >
          {isSaving ? t('users.edit.saving') : t('charities.settings.save')}
        </button>
      }
    >
      <div className="row g-3">
        <div className="col-12">
          <CharityLocationField
            label={t('charities.settings.volunteer_location')}
            onChange={place => onLocationChange('volunteer', place)}
            placeholder={t('users.edit.search')}
            value={clearedLocations.volunteer ? null : locations.volunteer}
          />
        </div>
        <div className="col-12">
          <CharityLocationField
            label={t('charities.settings.donation_location')}
            onChange={place => onLocationChange('donation', place)}
            placeholder={t('users.edit.search')}
            value={clearedLocations.donation ? null : locations.donation}
          />
        </div>
        <div className="col-12">
          <CharityLocationField
            label={t('charities.settings.visitor_location')}
            onChange={place => onLocationChange('visitor', place)}
            placeholder={t('users.edit.search')}
            value={clearedLocations.visitor ? null : locations.visitor}
          />
        </div>
      </div>
    </SettingsCard>
  )
}

CharityLocationsCard.propTypes = {
  locations: PropTypes.shape({
    volunteer: PropTypes.object,
    donation: PropTypes.object,
    visitor: PropTypes.object,
  }).isRequired,
  clearedLocations: PropTypes.shape({
    volunteer: PropTypes.bool,
    donation: PropTypes.bool,
    visitor: PropTypes.bool,
  }).isRequired,
  onLocationChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  hasChanged: PropTypes.bool,
  isSaving: PropTypes.bool,
}
